/**
 * inline-variants.js  —  Derpy Cards
 *
 * Condition pills + inline ADD TO CART on product cards.
 * Loaded before </body> in theme.liquid:
 *   <script src="{{ 'inline-variants.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── The card's CURRENT-price element ──────────────────────────────────────
  // On sale cards the theme renders <del><span class="amount">compare-at</span>
  // </del> BEFORE the current price, so "first .amount" was the struck-through
  // price — writing into it showed the sale price twice and hid the discount.
  function getPriceEl(inlineWrapper) {
    var info = inlineWrapper.closest('.product-card-info');
    if (!info) return null;
    return info.querySelector('.price ins .amount') ||
      info.querySelector('.price .amount:not(del .amount)') ||
      info.querySelector('.price');
  }

  // ── Set each NEW card's price to its preselected variant ─────────────────
  // Idempotent: cards already set are skipped, so re-running it (infinite
  // scroll appends, late-loading recommendation carousels) can't reset a
  // condition the shopper already picked back to the default price.
  // ── Non-condition options (colours, designs…) with dozens of variants ──────
  // printed dozens of pills and stretched every card in the row to ~1,100px.
  // Keep 6 (plus the preselected one) and link to the product for the rest;
  // also stop calling them "Condition".
  var CONDITION = /^(near mint|lightly played|moderately played|heavily played|damaged|mint|gem mint|excellent|nm|lp|mp|hp|dmg)\b/i;
  var PILL_CAP = 3;
  function capPills(wrapper) {
    var opts = wrapper.querySelector('.inline-variants__options');
    if (!opts) return;
    var labels = [].slice.call(opts.querySelectorAll('.inline-variant-label'));
    var isCondition = labels.every(function (l) { return CONDITION.test(l.textContent.trim()); });
    if (isCondition) return;
    opts.setAttribute('aria-label', 'Options');
    if (labels.length <= PILL_CAP + 1) return;
    /* keep the selected pill (it counts toward the cap), then available
       variants before sold-out ones */
    var keep = labels.filter(function (l) { return l.querySelector('input:checked'); });
    labels.forEach(function (l) {
      if (keep.length < PILL_CAP && keep.indexOf(l) < 0 && !l.classList.contains('is-unavailable')) keep.push(l);
    });
    labels.forEach(function (l) {
      if (keep.length < PILL_CAP && keep.indexOf(l) < 0) keep.push(l);
    });
    var hidden = 0;
    labels.forEach(function (l) {
      if (keep.indexOf(l) < 0) { l.style.display = 'none'; hidden++; }
    });
    var card = wrapper.closest('.product-card, product-card');
    var link = card && card.querySelector('a.product-card--image-link, a.product-card-title');
    if (hidden && link) {
      var more = document.createElement('a');
      more.className = 'inline-variants__more';
      more.href = link.getAttribute('href');
      more.textContent = '+' + hidden + ' more';
      opts.appendChild(more);
    }
  }

  function initPrices() {
    document.querySelectorAll('.inline-variants[data-initial-price]:not([data-derpy-priced])').forEach(function (wrapper) {
      wrapper.setAttribute('data-derpy-priced', '1');
      capPills(wrapper);
      var rawPrice = parseInt(wrapper.dataset.initialPrice, 10);
      if (isNaN(rawPrice) || rawPrice === 0) return;
      var priceEl = getPriceEl(wrapper);
      if (priceEl) priceEl.textContent = formatMoney(rawPrice);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrices);
  } else {
    initPrices();
  }
  window.DerpyInitPrices = initPrices; // re-run for cards appended after load (infinite gallery)

  // Cards that arrive later ("You may also like", recently viewed, quick view)
  // showed the product's "From" price while their ADD TO CART added the
  // preselected — dearer — variant. Price them as they appear.
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; initPrices(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function clearMsg(wrapper) {
    var m = wrapper && wrapper.querySelector('.inline-atc-msg');
    if (m) m.remove();
  }
  function showMsg(wrapper, text) {
    if (!wrapper) return;
    var m = wrapper.querySelector('.inline-atc-msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'inline-atc-msg';
      m.setAttribute('role', 'alert');
      wrapper.appendChild(m);
    }
    m.textContent = text;
  }

  // ── Radio change → update button variant ID + price in card-info ──────────────
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('.inline-variants input[type="radio"]')) return;

    var wrapper = radio.closest('.inline-variants');
    if (!wrapper) return;
    clearMsg(wrapper);

    var btn = wrapper.querySelector('.inline-atc-btn');
    var isAvailable = radio.dataset.available === 'true';
    var rawPrice = parseInt(radio.dataset.priceRaw, 10);

    if (btn) {
      btn.dataset.variantId = radio.value;
      btn.disabled = !isAvailable;
      btn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    if (!isNaN(rawPrice)) {
      var priceEl = getPriceEl(wrapper);
      if (priceEl) priceEl.textContent = formatMoney(rawPrice);
    }
  });

  // ── Open the cart drawer with fresh contents ─────────────────────────────
  // (the old code dispatched 'cart-drawer:open', which the theme only EMITS
  // after opening — nothing listened, so the drawer never opened)
  function renderAndOpenDrawer(res) {
    var drawer = document.getElementById('Cart-Drawer');
    var sections = res && res.sections;
    if (sections) {
      try {
        var parse = function (html, sel) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
          return el ? el.innerHTML : null;
        };
        if (drawer && sections['cart-drawer']) {
          var inner = parse(sections['cart-drawer'], '.cart-drawer');
          /* #Cart-Drawer IS the .cart-drawer element — searching inside it
             found nothing and the drawer opened with stale contents. The
             theme's own renderContents falls back to the element itself. */
          var target = drawer.matches('.cart-drawer') ? drawer : (drawer.querySelector('.cart-drawer') || drawer);
          if (inner !== null && target) target.innerHTML = inner;
          if (typeof drawer.notesToggle === 'function') drawer.notesToggle();
          if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
        }
        var bubble = document.getElementById('cart-drawer-toggle');
        if (bubble && sections['cart-bubble']) {
          var count = parse(sections['cart-bubble'], '.thb-item-count');
          var countEl = bubble.querySelector('.thb-item-count');
          if (count !== null && countEl) countEl.innerHTML = count;
        }
      } catch (err) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  // ── Add to Cart button click → AJAX, then open the cart drawer ─────────────
  document.addEventListener('click', function (e) {
    var btn = e.target;
    if (!btn.matches || !btn.matches('.inline-atc-btn')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var wrapper = btn.closest('.inline-variants');
    clearMsg(wrapper);
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: 'cart-drawer,cart-bubble',
        sections_url: location.pathname
      })
    })
    .then(function (r) {
      if (r.ok) return r.json();
      // 422 etc.: Shopify explains why (e.g. "All 1 … are in your cart")
      return r.json().catch(function () { return {}; }).then(function (j) {
        var err = new Error(j.description || j.message || ('Cart add failed: ' + r.status));
        err.userMessage = j.description || j.message || '';
        throw err;
      });
    })
    .then(function (res) {
      btn.textContent = 'Added!';
      renderAndOpenDrawer(res);
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function (err) {
      console.error('[inline-variants] Cart add error:', err);
      btn.disabled = false;
      btn.textContent = originalText;
      showMsg(wrapper, err.userMessage || 'Sorry, this item could not be added to your cart.');
    });
  });

})();
